import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_PERIODS } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import formatDate from '@/lib/display/formatDate'

const payRateTypes = {
  namespaced: true,
  state: buildInitialState({
    periodsList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setPeriods: (state, periodsList) => {
      let list = []
      if (Array.isArray(periodsList)) {
        list = periodsList
      } else {
        list = [periodsList]
      }
      let index = 0
      state.periodsList = list.map(
        (item) => {
          return {
            value: index++,
            text: formatDate(item.dateBegin) + ' - ' + formatDate(item.dateEnd),
            dateBegin: item.dateBegin,
            dateEnd: item.dateEnd
          }
        })
    }
  },
  actions: {
    getPeriods: ({ commit }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      return api.doGet({ path: PATH_PERIODS, parameters: filters })
        .then(json => json.data)
        .then(periodsList => {
          commit('updateStatus', { status: COMPLETE })
          commit('setPeriods', periodsList)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default payRateTypes
